<div class="m-progress-stepper" [ngClass]="styleClass">
  <p-steps
    [model]="steps"
    [readonly]="readonly"
    [activeIndex]="activeStep"
    [styleClass]="computedStyleClass()"
    (activeIndexChange)="onActiveIndexChange($event)" />
</div>
